import React from 'react';
import { useTheme, chartColors } from '../../theme/useTheme';
import ReactApexChart from 'react-apexcharts';
import { toMoneyUnit, formatUnitValue, moneyLabel, MONEY_UNIT } from '../../utils/format';

export interface TrendDatum {
  label: string;
  /** Rupees. */
  value: number;
  color: string;
}



/** Vertical bars, one colour per bar (shared BarChart supports a single colour only). */
const TrendChart: React.FC<{ data: TrendDatum[]; height?: number }> = ({ data, height = 260 }) => {
  const { theme } = useTheme();
  const cc = chartColors(theme);
  const options: any = {
    chart: { type: 'bar', toolbar: { show: false }, background: 'transparent', fontFamily: 'inherit' },
    theme: { mode: theme },
    colors: data.map((d) => d.color),
    plotOptions: { bar: { distributed: true, borderRadius: 4, columnWidth: '45%', dataLabels: { position: 'top' } } },
    dataLabels: { enabled: true, formatter: (v: number) => formatUnitValue(v), offsetY: -18, style: { fontSize: '11px', colors: [cc.text] } },
    grid: { borderColor: cc.grid, strokeDashArray: 3 },
    xaxis: { categories: data.map((d) => d.label), labels: { style: { colors: cc.muted, fontSize: '11px' } }, axisBorder: { show: false } },
    yaxis: {
      title: { text: `Sales (${moneyLabel()})`, style: { color: cc.muted, fontSize: '11px', fontWeight: 400 } },
      labels: { style: { colors: cc.muted }, formatter: (v: number) => (typeof v === 'number' ? v.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : v) },
    },
    tooltip: { theme, y: { formatter: (v: number) => `₹${formatUnitValue(v)} ${MONEY_UNIT.key}` } },
    legend: { show: false },
  };
  return <ReactApexChart type="bar" height={height} options={options} series={[{ name: `Sales (${moneyLabel()})`, data: data.map((d) => toMoneyUnit(d.value)) }]} />;
};

export default TrendChart;
